/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const CommitText = styled.span({
  fontFamily: token('font.family.code'),
});
export const MessageText = styled.span({
  margin: `0 0 0 ${token('space.050')}`,
});
